const LessonWatchVideo = ({ lessonData }) => {

  return (
    <div>
      LessonWatchVideo Component
    </div>
  )
}

export default LessonWatchVideo
